module.exports = __webpack_public_path__ + "static/media/logo-zapier.49a73398.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-zapier.png
// module id = 1311
// module chunks = 17